import React, { useState } from 'react';
import { processService } from '../services/processService.ts';
import { useProject } from '../context/ProjectContext.tsx';
import { useFilters } from '../context/FilterContext.tsx';
import { useReviewer } from '../context/ReviewerContext.tsx';
import { ReviewType } from '../types/index.ts';

export function ProcessSection() {
    const { currentProject } = useProject();
    const { lit_filter } = useFilters();
    const [llmProvider, setLlmProvider] = useState(0);
    const { currentReviewer } = useReviewer();

    const handleProcess = async (only_abstracts: boolean) => {
        if (!currentProject) return;

        try {
            const response = await processService.processLiterature({
                reviewer_id: llmProvider,
                lit_filter: {
                    ...lit_filter,
                    review_type: only_abstracts ? ReviewType.ABSTRACT : ReviewType.FULL_PAPER,
                },
            });
            if (response.ok) {
                console.log('Processing started');
            }
        } catch (error) {
            console.error('Error starting processing:', error);
        }
    };

    const retrieveFullTexts = async () => {
        if (!currentProject) return;

        try {
            const response = await processService.retrieveFullTexts(lit_filter);
            if (response.ok) {
                console.log('Full text retrieval started for filtered papers');
            }
        } catch (error) {
            console.error('Error starting full text retrieval:', error);
        }
    };

    return (
        <div className="process-section">
            <h2>Process Literature</h2>
            <div className="process-controls">
                <select
                    value={llmProvider}
                    onChange={(e) => setLlmProvider(Number(e.target.value))}
                    className="provider-select">
                    <option>Please select provider</option>
                    {currentReviewer
                        ?.filter((r) => r.type === 'ai')
                        .map((r) => (
                            <option key={r.id} value={r.id}>
                                {r.name}
                            </option>
                        ))}
                </select>
                <button onClick={() => handleProcess(true)} className="process-button">
                    Process All Abstracts
                </button>
                <button onClick={retrieveFullTexts} className="retrieve-fulltext-button">
                    Retrieve Full Texts
                </button>
                <button onClick={() => handleProcess(false)} className="process-button">
                    Process Full Text
                </button>
            </div>
        </div>
    );
}
